"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotCreditCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotCreditCard = _ref => {
  let {
    spotColor = "#E4EDFE",
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M17.798 6.933c-3.35.756-8.67 2.033-12.548 5.833-3.878 3.81-6.665 10.498-4.485 14.332 2.192 3.823 9.352 4.78 15.657 6.315 6.317 1.545 11.77 3.665 15.58 1.95 3.798-1.713 5.934-7.25 7.07-12.02 1.145-4.77 1.27-8.762.156-12.1-1.1-3.337-3.462-6.01-6.148-6.89-2.698-.868-5.732.046-8.127.813-2.394.766-3.795 1-7.155 1.767Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinejoin: "round",
    strokeWidth: 2.2,
    d: "M2.857 16.965h34.286M5.974 7.857h28.052c1.722 0 3.117 1.36 3.117 3.036v18.214c0 1.677-1.395 3.036-3.117 3.036H5.974c-1.721 0-3.117-1.359-3.117-3.036V10.893c0-1.676 1.396-3.036 3.117-3.036Zm20.62 17.895h7.252v3.196h-7.252v-3.196Z"
  }));
};
exports.SpotCreditCard = SpotCreditCard;
SpotCreditCard.displayName = "SpotCreditCard";